import type { App } from "vue"
import type { AxiosResponse } from "axios"
import axios from "axios"
import VueAxios from "vue-axios";

class ApiService {
  public static vueInstance: App;

  public static init(app: App<Element>) {
    ApiService.vueInstance = app;
    ApiService.vueInstance.use(VueAxios, axios);
    ApiService.vueInstance.axios.defaults.baseURL = import.meta.env.VITE_API_URL;

    // remove old token
    ApiService.vueInstance.axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('id_token')
          window.location.href = '/login';
        }

        return Promise.reject(error);
      }
    );
  }

  private static getHeaders() {
    return {
      Authorization: `Bearer ${localStorage.getItem('id_token')}`,
    };
  }

  public static get(
    resource: string,
    params = '',
  ): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.get(`${resource}${params}`, {
      headers: ApiService.getHeaders()
    });
  }

  public static getFile(
    resource: string,
    params = '',
  ): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.get(`${resource}${params}`, {
      headers: ApiService.getHeaders(),
      responseType: 'blob'
    });
  }

  public static post(resource: string, params: any): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.post(`${resource}`, params, {
      headers: ApiService.getHeaders()
    });
  }

  public static put(resource: string, params: any): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.put(`${resource}`, params, {
      headers: ApiService.getHeaders()
    });
  }

  public static patch(resource: string, params: any): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.patch(`${resource}`, params, {
      headers: ApiService.getHeaders()
    });
  }

  public static delete(resource: string, data?: any): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.delete(resource, {
      headers: ApiService.getHeaders(),
      data: data
    });
  }
}

export default ApiService;
